import { Block, Tooltip, Typography } from '@klp/design';
import { IconName, Illustration } from '@klp/design/Illustrations';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Alert } from '@material-ui/lab';

import FrontpageCardsSelector from './FrontpageCardsSelector';
import { frontpageSelectors } from '../store/frontpageSlice';

export default function AdjustFrontpageDialog() {
    const { t } = useTranslation();
    const { storedSelectedFrontpageCards } = useSelector(frontpageSelectors);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <Tooltip translation="frontPage.adjustFrontpage.title" title="">
                <IconButton onClick={handleOpen} size="small" color="secondary">
                    <Illustration icon={IconName.GEAR} />
                </IconButton>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogTitle>
                    {t('frontPage.adjustFrontpage.title')}
                </DialogTitle>
                {storedSelectedFrontpageCards?.length <= 0 && (
                    <Block padding="compact">
                        <Alert severity="info">
                            <Typography variant="body1">
                                {t('frontPage.adjustFrontpage.alert')}
                            </Typography>
                        </Alert>
                    </Block>
                )}
                <DialogContent>
                    <FrontpageCardsSelector />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        {t('general.close')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
